import CryptoJS from 'crypto-js';

export const CAPTCHA_API_URL = 'https://captcha.ety.one/api/captcha';

const delay = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds));

export const hasLeadingZeroBits = (hexDigest, difficulty) => {
    const fullNibbles = Math.floor(difficulty / 4);
    const remainingBits = difficulty % 4;
    if (!hexDigest.startsWith('0'.repeat(fullNibbles))) return false;
    if (remainingBits === 0) return true;
    const nextNibble = Number.parseInt(hexDigest[fullNibbles], 16);
    return nextNibble < (1 << (4 - remainingBits));
};

export const solveProofOfWork = async (challenge, difficulty, signal) => {
    if (!challenge || difficulty < 1 || difficulty > 22) {
        throw new Error('Некорректное задание проверки');
    }

    const batchSize = 600;
    for (let nonce = 0; nonce < 50_000_000; nonce += batchSize) {
        if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
        const batchEnd = nonce + batchSize;
        for (let candidate = nonce; candidate < batchEnd; candidate += 1) {
            const digest = CryptoJS.SHA256(`${challenge}:${candidate}`).toString();
            if (hasLeadingZeroBits(digest, difficulty)) return String(candidate);
        }
        // Keep typing, animation and mobile scrolling responsive while computing.
        await delay(0);
    }
    throw new Error('Не удалось выполнить фоновую проверку');
};

const parseResponse = async (response) => {
    if (!response.ok) {
        const error = new Error(`Captcha HTTP ${response.status}`);
        error.status = response.status;
        throw error;
    }
    return response.json();
};

export const requestCaptcha = async (signal) => {
    const response = await fetch(CAPTCHA_API_URL, { signal, cache: 'no-store' });
    return parseResponse(response);
};

export const verifyVisualCaptcha = async (token, code, signal) => {
    const response = await fetch(`${CAPTCHA_API_URL}/verify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, code }),
        signal,
    });
    return response.ok;
};

export const verifyPassiveCaptcha = async (challenge, honeypot, signal) => {
    const startedAt = Date.now();
    const proof = await solveProofOfWork(challenge.proofChallenge, challenge.proofDifficulty, signal);
    // The server rejects unrealistically instant answers; this normally finishes during form entry.
    const remainingDelay = Math.max(0, 700 - (Date.now() - startedAt));
    if (remainingDelay) await delay(remainingDelay);

    const response = await fetch(`${CAPTCHA_API_URL}/verify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: challenge.token, proof, website: honeypot || '' }),
        signal,
    });
    return response.ok;
};
